export { default, type EventSectionProps } from './EventsSection';
